import { createContext, useContext } from 'react';

export const TemplateListContext = createContext(undefined);

export const useTemplateListContext = () => {
  const cxt = useContext(TemplateListContext);

  if (!cxt)
    throw new Error('useTemplateListContext must be used with provider');

  return cxt;
};
